var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingPageTopLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 88,
    viewBox: "0 0 120 88",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-16.7081 87.4455C58.5629 87.4455 119.584 45.1617 119.584 -7H-153C-153 45.1602 -91.9791 87.4455 -16.7081 87.4455Z",
    fill: "#FED57A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPageTopLeft);
export default __webpack_public_path__ + "static/media/landingPageTopLeft.1cbdc578dd8d64c91428ed28de52a9cf.svg";
export { ForwardRef as ReactComponent };